export default __webpack_public_path__ + "static/media/screenShots_poland-2.b6807add.jpg";